import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import { Divider } from "@/components/ui/divider";
import i18n from "i18n-js";
import React, { useEffect } from 'react';
import Footer from "../components/basic/Footer";
import { switchScreen } from '../hooks/navigate';
import BasicButton from "../components/basic/BasicButton";
import FloatingLabelInput from "../components/basic/FloatingLabelInput";

export default function Alternatives({ route, navigation }) {
    const { title, screenA, paramsA, textA, screenB, paramsB, textB, hint } = route.params

    useEffect(() => {
        navigation.setOptions({ title: i18n.t(title) })
    }, [title])

    return (
        <View className="flex-1 bg-secondary-50">
            <VStack space='xl' className="flex-1 mt-10 px-3">
                <BasicButton onPress={() => switchScreen(navigation, screenA, paramsA)} text={i18n.t(textA)} />
                <VStack className="justify-center px-[10px]">
                    <Divider className="m-1 self-center" />
                    <Text className="absolute self-center px-2 bg-secondary-50 text-secondary-900">{i18n.t('addContact.or')}</Text>
                </VStack>
                <BasicButton onPress={() => switchScreen(navigation, screenB, paramsB)} text={i18n.t(textB)} />
                {hint && <FloatingLabelInput label={i18n.t('accountSettings.hint')} size='lg' h='h-[300px]' multiline={true} isDisabled={true} value={i18n.t(hint)}/>}
            </VStack>
            <Footer navigation={navigation} />
        </View>
    );
}
